import { useWizard } from "react-use-wizard";
import React from "react";
import NavigateBack from "../../components/navigateBack";
import Address from "../../components/address";

function AddressStep({ qKey, onSubmitHandler, state }) {
  const { previousStep, nextStep } = useWizard();
  const _qKey = qKey;

  const onNextFn = (data) => {
    onSubmitHandler({ [_qKey]: data });
    nextStep();
  };

  return (
    <>
      <NavigateBack onClickHandler={previousStep} />
      <Address initState={state} onSubmitHandler={onNextFn} />
    </>
  );
}

export default AddressStep;
